/* eslint-disable import/no-anonymous-default-export */
export default {
  allAccounts: "/flexible-plan/worker/grouped-user/quotations",
  oldallAccounts: "/flexible-plan/user/all",
  ppaSummary: "/flexible-plan/account/ppa/summary",
  allPpaSummary: "/flexible-plan/account/ppa/all/accepted",
  flexiInitialQuotations: "/flexible-plan/worker/all/initial",
  initialQuotations: "/quotation/worker/all/initial",
  flexiQuotations: "/flexible-plan/worker/all",
  flexiPolicy: "/flexible-plan/worker/all/accepted",
  policy: "/quotation/worker/all/accepted",
  flexiApplications: "/flexible-plan/worker/all/application",
  applications: "/quotation/worker/all/application",
  createFlexiQuotation: "/flexible-plan/worker/savings-loan",
  viewFlexiQuotation: "/flexible-plan",
  updateBenefits: "/flexible-plan/worker/benefit/savings-loan",
  downloadPdf: "/flexible-plan/user/generate-pdf/",
  generateUnderwritingSummaryPdf:
    "/flexible-plan/user/download/health-underwriting-pdf/",
  generateFinancialUnderwritingSummaryPdf:
    "/flexible-plan/user/download/financial-underwriting-pdf/",
};
